import firebase from "../../config/fbConfig";
import "../../../node_modules/firebase/firestore";
import "../../../node_modules/firebase/storage";

function GetLogo(logos) {
  switch (logos.dropdown) {
    case "local":
      UploadFile(logos.localFile);
      return logos.localLabel;
    case "web":
      return logos.webUrl;
    default:
      return logos.name;
  }
}

function GetLogoWidth(logos) {
  switch (logos.dropdown) {
    case "local":
      return logos.localWidth;
    case "web":
      return logos.webWidth;
    default:
      return "";
  }
}

function UploadFile(file) {
  const storageRef = firebase.storage().ref();
  const imageRef = storageRef.child(file.name);
  imageRef.put(file);
  return `gs://zoom-back.appspot.com/${file.name}`;
}

export default function CreateTemplate(clientId, info, colors, logos) {
  firebase
    .firestore()
    .collection("templates")
    .doc(clientId)
    .set({
      name: info.name,
      position: info.position,
      clientId,
      textColor: colors.textColor,
      backgroundColor: colors.backgroundColor,
      dropdown: logos.dropdown,
      logo: GetLogo(logos),
      logoColor: colors.logoColor,
      logoWidth: GetLogoWidth(logos),
      createdAt: new Date(),
      watermarkHidden: logos.watermarkHidden
    })
    .then(function () {
      console.log("Document successfully written!");
    })
    .catch(function (error) {
      console.error("Error writing document: ", error);
    });
}
